import { RentProjectionResponse } from '@models/RentProjectionResponse';
import React from 'react';
import { UnitFeatures } from '../../../codecs/revenueEstimate';
import { AnnualRevenueEstimate } from './AnnualRevenueEstimate';
// import { RateGroup } from './RateGroup';
import * as styled from './styled/RecalculateGroup.styled';

export const RecalculateGroup: React.FC<{
    estimate: RentProjectionResponse | UnitFeatures;
    isLoading?: boolean;
}> = ({ estimate, isLoading }) => {
    return (
        <styled.RecalculateGroup>
            <AnnualRevenueEstimate isLoading={isLoading} estimate={estimate} />
            {/* <RateGroup isLoading={isLoading || false} estimate={estimate} /> */}
        </styled.RecalculateGroup>
    );
};
